import React from 'react';

export interface Props {
  className?: string;
}

const PremiumGallery24: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="12"
    height="12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 0.75H2.25V1.875H9.825C9.99069 1.875 10.125 2.00931 10.125 2.175V9.75H11.25V1.5C11.25 1.08579 10.9142 0.75 10.5 0.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 3.75C0.75 3.33579 1.08579 3 1.5 3H8.25C8.66421 3 9 3.33579 9 3.75V10.5C9 10.9142 8.66421 11.25 8.25 11.25H1.5C1.08579 11.25 0.75 10.9142 0.75 10.5V3.75ZM6.96553 5.77721L6.02702 5.28904C5.91361 5.23005 5.77136 5.2385 5.66773 5.31038L4.875 5.86016L4.08227 5.31038C3.97864 5.2385 3.83639 5.23005 3.72298 5.28904L2.78447 5.77721C2.68572 5.82858 2.625 5.92284 2.625 6.02478V7.29191C2.625 7.37378 2.66426 7.45174 2.73288 7.50613L4.66145 9.03475C4.78324 9.13128 4.96676 9.13128 5.08855 9.03475L7.01712 7.50613C7.08574 7.45174 7.125 7.37378 7.125 7.29191V6.02478C7.125 5.92284 7.06428 5.82858 6.96553 5.77721Z"
      fill="currentColor"
    />
  </svg>
);
PremiumGallery24.displayName = 'Commission24';

export default PremiumGallery24;
